export default __webpack_public_path__ + "static/media/title.7a1c25e1.png";